export default "__VITE_ASSET__DzywdbrT__"